export default __webpack_public_path__ + "static/media/aqua_red.495f3468.png";